import React from 'react';
import { useEffect, useState } from 'react';
import framework from 'utils/framework';
const { wrapFunctionalComponent } = framework;
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { Text, Box, Button } from 'components/ui';
import passkeysUtils from 'utils/passkeys';
import {
    fontSizes, lineHeights, fontWeights, space
} from 'style/config';
import ResetPasswordEN from 'pages/Auth/ResetPassword/locales/ResetPassword_en_US';
import ResetPasswordFR from 'pages/Auth/ResetPassword/locales/ResetPassword_fr_CA';
import { SCREENS } from 'pages/Auth/ResetPassword/constants';

const getText = LanguageLocaleUtils.getLocalisedDataFromResource(ResetPasswordEN, ResetPasswordFR);

/**
 * TOKEN_ERROR — SIM-18 / ACS-4355 / SUB-TASK-4.
 *
 * Renders the invalid/expired-token error copy plus a "Reset Password" CTA
 * that transitions back to the initial screen (PASSKEY_FIRST_LANDING when
 * the async passkey check says passkeys are ENABLED, TRADITIONAL_RESET
 * otherwise). Explicitly does NOT dispatch `Actions.showForgotPasswordModal`
 * — the ctrlr used to; this page replaces the modal (BR-014).
 */
const TokenError = ({ onTransition }) => {
    // The initial-screen resolver here runs on click so we don't have to
    // duplicate the root's async KS check. `passkeysUtils.isPasskeyEnabled`
    // is a synchronous read of `Sephora.configurationSettings` — safe to
    // call directly from the click handler.
    const [initialTarget, setInitialTarget] = useState(SCREENS.TRADITIONAL_RESET);

    useEffect(() => {
        // Cheap sync check to pick the restart target ahead of the click.
        if (passkeysUtils.isPasskeyEnabled()) {
            setInitialTarget(SCREENS.PASSKEY_FIRST_LANDING);
        }
    }, []);

    const handleRestart = () => {
        onTransition(initialTarget);
    };

    return (
        <>
            <Text
                is='h1'
                fontSize={fontSizes.lg}
                fontWeight={fontWeights.bold}
                lineHeight={lineHeights.tight}
                marginBottom={4}
            >
                {getText('resetLinkExpiredTitle')}
            </Text>

            <Text
                is='p'
                fontSize={fontSizes.md}
                lineHeight={lineHeights.base}
                marginBottom={5}
            >
                {getText('resetLinkExpired')}
            </Text>

            <Box marginTop={3}>
                <Button
                    variant='primary'
                    type='button'
                    width='100%'
                    paddingY={space[3]}
                    onClick={handleRestart}
                >
                    {getText('resetPasswordButton')}
                </Button>
            </Box>
        </>
    );
};

export default wrapFunctionalComponent(TokenError, 'TokenError');
